import dotenv from 'dotenv';

dotenv.config();

export const productionConfig = {
    depService: `${process.env.VUE_APP_DEP_SERVICE}`,
}

export const developmentConfig = {
    depService: `${process.env.VUE_APP_DEP_SERVICE}`,
}

export const stagingConfig = {
    depService: `${process.env.VUE_APP_STAGING_DEP_SERVICE}`,
}

const environment = getEnvironment()

export const environmentConfig = getEnvObject();

function getEnvironment() {
    let base_url = window.location.origin;
    if (base_url.includes('staging')) return 'staging'
    if (base_url.includes('localhost')) return 'development'
    else return 'production'
}

function getEnvObject() {
    if (environment === 'staging') return developmentConfig
    if (environment === 'development') return developmentConfig
    if (environment === 'production') return productionConfig
}
